export default __webpack_public_path__ + "static/media/686.3dd040f0.png";